import Customer from "@/components/master/customer/Customer.vue";
import CustomerAdd from "@/components/master/customer/CustomerAdd.vue";
import CustomerDetail from "@/components/master/customer/CustomerDetail.vue";
import CustomerEdit from "@/components/master/customer/CustomerEdit.vue";
import CustomerUpload from "@/components/master/customer/CustomerUpload.vue";

let routesCustomer = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "CustomerIndex",
        component: Customer
      },
      {
        path: 'add',
        meta: {
          title: "Sales System",
        },
        name: "CustomerAdd",
        component: CustomerAdd
      },
    
      {
        path: 'edit/:id',
        meta: {
          title: "Sales System",
        },
        name: "CustomerEdit",
        component: CustomerEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Sales System",
        },
        name: "CustomerDetail",
        component: CustomerDetail
      },
    
      {
        path: 'upload',
        meta: {
          title: "Sales System",
        },
        name: "CustomerUpload",
        component: CustomerUpload
      },
  ]
  
  export default routesCustomer
  